import { ErrorResponse, fetchAPI } from '@quickbit/backoffice-core-frontend';
import { toSnakeCase } from '@quickbit/backoffice-core-frontend/src/api/fetchAPI';
import { useQuery } from '@tanstack/react-query';

export interface GroupCount {
  key: string;
  created: number;
  managed: number;
  reportedToFipo: number;
}

export interface PeriodStat {
  period: string;
  created: number;
  managed: number;
  reportedToFipo: number;
  perGroup: GroupCount[];
}

export interface CaseStatisticsResponse {
  granularity: string;
  groupBy: string;
  totalCreated: number;
  totalManaged: number;
  totalReportedToFipo: number;
  perGroup: GroupCount[];
  periods: PeriodStat[];
}

const queryKeys = {
  all: () => ['fcu', 'case-statistics'] as const,
  list: (query: string) => [...queryKeys.all(), query] as const,
};

export const useGetCaseStatistics = (query: Record<string, any>) => {
  const queryString = new URLSearchParams(
    Object.fromEntries(
      Object.entries(toSnakeCase(query))
        .filter(([, value]) => value !== undefined)
        .map(([key, value]) => [key, String(value)])
    )
  ).toString();
  return useQuery<CaseStatisticsResponse, ErrorResponse>({
    queryKey: queryKeys.list(queryString),
    queryFn: async () => {
      return await fetchAPI<CaseStatisticsResponse>(
        `v1/fcu/case-statistics${queryString ? `?${queryString}` : ''}`
      );
    },
  });
};
